import {ClickAwayListener, IconButton, Tooltip, useMediaQuery, useTheme} from "@mui/material"
import InfoIcon from '@mui/icons-material/Info';
import { use, useState } from "react";
import {translateKey} from "../../utils/fieldsFormatters";
import {LanguageContext} from "../../context/LanguageContext";

interface InfoTooltipProps {
    text: string
    noPadding?: boolean
}


const InfoTooltip = ({text, noPadding = false}: InfoTooltipProps) => {

    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.between('xs', 'md'));
    const {language} = use(LanguageContext);

    const [open, setOpen] = useState(false)
    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return mobileView ? <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip title={<div dangerouslySetInnerHTML={{__html: text}}/>} open={open}
                  placement={'bottom'} arrow>
            <IconButton onClick={handleTooltipOpen} aria-label={translateKey('details', language)} className={noPadding ? 'no-padding' : ''}>
                <InfoIcon/>
            </IconButton>
        </Tooltip>
    </ClickAwayListener> : <Tooltip title={<div dangerouslySetInnerHTML={{__html: text}}/>}
                                     placement={'right'}
                                    arrow>
        <IconButton aria-label={translateKey('details', language)} className={noPadding ? 'no-padding' : ''}>
            <InfoIcon/>
        </IconButton>
    </Tooltip>
}

export default InfoTooltip